import type { AgentSession } from '../../api/memory-v2'

interface SessionHistoryProps {
  sessions: AgentSession[]
  onSelect?: (sessionId: string) => void
}

function formatTimestamp(value: string | undefined): string {
  if (!value) return ''
  try {
    return new Date(value).toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    })
  } catch {
    return value
  }
}

export function SessionHistory({ sessions, onSelect }: SessionHistoryProps) {
  if (sessions.length === 0) {
    return <p className="text-sm text-harbor-text-secondary">No sessions yet.</p>
  }
  return (
    <ul className="space-y-2">
      {sessions.map((session) => (
        <li key={session.sessionId}>
          <button
            type="button"
            onClick={() => onSelect?.(session.sessionId)}
            aria-label={`Open session ${session.sessionId}`}
            className="w-full rounded-lg border border-harbor-border bg-harbor-surface p-3 text-left hover:border-harbor-accent"
          >
            <div className="flex items-center gap-2">
              <span className="text-sm font-medium text-harbor-text">{session.sessionId}</span>
              <span className="rounded-full bg-harbor-surface-raised px-2 py-0.5 text-xs text-harbor-text-secondary">
                {session.status}
              </span>
              <span className="text-xs text-harbor-text-muted">{session.sourceClient}</span>
            </div>
            <div className="mt-1 text-xs text-harbor-text-muted">
              {formatTimestamp(session.lastEventAt)}
              {session.extractionStatus !== 'processed' && (
                <span className="ml-2">extraction {session.extractionStatus}</span>
              )}
            </div>
          </button>
        </li>
      ))}
    </ul>
  )
}
